/* global angular, $ */
angular.module('ua5App')
    .directive('resourceMap', ['$timeout', '$rootScope', '$sce', function($timeout, $rootScope, $sce) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-map/resource-map.html',
            scope: {
                content: '=',
                contentTitle: '@',
                sectionIndex: '@'
            },
            link: function($scope, element, attrs) {
                $scope.sortByRank = function(item) {
                    return parseInt(item.rank, 10);
                };

                $scope.currentLocation = {address: ''};

                $scope.markerTracker = [];

                $scope.content = $scope.content['map-content'];
                // setting up marker tracker to see which ones should have active state
                for (var i = 0; i < $scope.content.length; i++) {
                    $scope.markerTracker[i] = [];
                    for (var j = 0; j < $scope.content[i].markers.length; j++) {
                        $scope.markerTracker[i][j] = false;
                        $scope.content[i].markers[j].gmap = $sce.trustAsResourceUrl($scope.content[i].markers[j].gmap);
                    }
                }

                $scope.markerClick = function(index, parentIndex) {
                    $scope.currentLocation = $scope.content[parentIndex].markers[index];
                    $scope.lightbox.fadeIn();

                };

                $scope.closeLightbox = function() {
                    $scope.lightbox.fadeOut();
                };

                $scope.markerTrack = function(index, parentIndex) {

                    //make all the markers on same map inactive
                    for (var i = 0; i < $scope.markerTracker[parentIndex].length; i++) {
                        if (i !== index) {
                            $scope.markerTracker[parentIndex][i] = false;
                        }
                    }
                    $scope.markerTracker[parentIndex][index] = true;
                };

                $scope.markerUntrack = function(index, parentIndex) {
                    if (index === 'all' && parentIndex > -1) {
                        for (var i = 0; i < $scope.markerTracker[parentIndex].length; i++) {
                            $scope.markerTracker[parentIndex][i] = false;
                        }
                    } else {
                        $scope.markerTracker[parentIndex][index] = false;
                    }
                };

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});

                    $scope.lightbox = $(element).find('.resources-map-lightbox');
                });
            }
        };
    }])
;
